/* eslint-disable react/prop-types */
import React from 'react';
import { Form, Input, Col } from 'antd';
import Uploader from 'components/Uploader';
import { toUpper } from 'utils/normalizers';
import { generateRFCRules } from 'utils/rules';

const rules = {
  required: [{ required: true }],
  rfc: generateRFCRules({ tipoDePersona: 1, required: true }),
};

const FirmaElectronica = ({
  firmado = false,
  firma_automatica = false,
  modal,
  disabled,
}) => {
  if (firmado) {
    return 'Trámite ha sido firmado por el responsable, puede continuar a siguiente(s) paso(s)';
  }

  if (firma_automatica) {
    return null;
  }

  return (
    <>
      <Uploader
        title="Certificado (.cer)"
        formItemName="archivo_cer"
        limitMB={50}
        allowedExtensions={['cer']}
        rules={rules.required}
        allowPreview={false}
        formItemClassName="no-capitalize"
        fullSize={modal}
        disabled={disabled}
      />
      <Uploader
        title="Clave privada (.key)"
        formItemName="archivo_key"
        limitMB={50}
        allowedExtensions={['key']}
        rules={rules.required}
        allowPreview={false}
        formItemClassName="no-capitalize"
        fullSize={modal}
        disabled={disabled}
      />
      <Col span={modal ? 24 : 8}>
        <Form.Item
          label="Contraseña de Clave privada"
          name="clave_privada"
          rules={rules.required}
        >
          <Input.Password visibilityToggle={false} autoComplete="off" disabled={disabled} />
        </Form.Item>
      </Col>
      <Col span={modal ? 24 : 8}>
        <Form.Item
          label="RFC"
          name="rfc"
          rules={rules.rfc}
          normalize={toUpper}
        >
          <Input disabled={disabled} />
        </Form.Item>
      </Col>
    </>
  );
};

export default FirmaElectronica;
